<template>
    <rkm-overlay>
        <rkm-layout-body title ="Reimpressão de protocolo">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List ref="List"/>
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/transporte-paciente/reimpressao-protocolo/List'

export default {
    components: { List },
    methods: {
        handleExit() {
            this.$router.push({ name: 'dashboard' })
        },
    }
}
</script>